import React from 'react';
import {useTranslation} from "react-i18next";
import GoalsForm from "../../components/Forms/GoalsForm";
import {ImeanHeader} from "../../components/Header/Header";
import {StickyNavigationHeader} from "../../components/Navigation/StickyNavigationHeader";
import {useNavigate} from "react-router-dom";

const Goals = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    return (
        <>
            <ImeanHeader initialDark={true}></ImeanHeader>
            <StickyNavigationHeader headerTitle={t('survey.survey')}
                                    onBackClick={() => navigate('/home')}></StickyNavigationHeader>
            <div>
                <h1 className="self-assessment-title">
                    {t("survey.title")}
                </h1>
            </div>
            <div className="survey-page pb-5">
                <div className="navbar">
                    <div className="menu-icon"></div>
                    <div className="title">{t("survey.survey")}</div>
                </div>

                <GoalsForm/>
            </div>
        </>
    );
};

export default Goals;